exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".css-kj6f9i-menu{\r\n    margin:0 !important;\r\n\r\n}\r\n\r\n.css-uxwzoy,.css-1wwvboz{\r\n    z-index: 1000001 !important;\r\n}\r\n\r\n.rnSelect input{\r\n    height: 18px !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n.rnSelect>div{\r\n\r\n    min-height: 33.5px !important;\r\n}\r\n\r\n.rnselect__dropdown-indicator,.rnselect__clear-indicator{\r\n    padding: 5.5px !important;\r\n}", ""]);

// exports
